import * as React from 'react';

import Button from '@mui/material/Button';
import { Navigate } from 'react-router';

import './StartButton.css';

interface Props {
	target: string;
}

interface NavigateState {
	navigate: string;
}

class StatButton extends React.Component<Props> {
	props: Props = {
		target: '',
	};

	state: NavigateState = {
		navigate: '',
	};

	constructor(props: Props) {
		super(props);
	}

	render() {
		return (
			<section className="app">
				<Button
					className="button"
					sx={{
						color: '#fff',
						textShadow: '0 0 8px #fff, 0 0 16px #fff, 0 0 32px #fff',
					}}
					onClick={() => {
						this.setState({ navigate: this.props.target });
					}}
				>
					New Scan
				</Button>
				{this.state.navigate && <Navigate to={this.state.navigate} />}
			</section>
		);
	}
}

export default StatButton;
